<div class="assign-tyre-container">
    <!-- Info Bar -->
    <!-- <div class="info-bar">
      <div class="info-item">Tyres selected: <strong>{{ totalTyresSelected }}</strong></div>
      <div class="info-item">Assigned to Horse: <strong>{{ assignedToHorse }}</strong></div>
      <div class="info-item">Assigned to Trailer: <strong>{{ assignedToTrailer }}</strong></div>
      <div class="warning-text" *ngIf="assignedToTrailer === 0">
        ⚠️ Trailer tyres not yet assigned
      </div>
    </div> -->
  <div class="d-flex">
    <!-- Visual Map Section -->
    <div class="visual-section col-md-6 col-sm-12">
        <div class="section-header">
          <span class="icon">🗺️</span>
          <span class="title">VISUAL POSITION MAP</span>
        </div>
        <p class="description">Click a slot to see tyre assigned. Blue = Horse • Purple = Trailer.</p>
    
        <!-- Type Buttons -->
        <div class="type-buttons">
          <button class="type-btn horse-type" *ngIf="selectedTypePosition === 'truck'">
            <span class="icon">🚚</span>
            Horse (TATA Prima)
          </button>
          <button class="type-btn trailer-type" *ngIf="selectedTypePosition === 'trailer'">
            <span class="icon">🚛</span>
            Trailer (Flatbed 40FT)
          </button>
        </div>
    
        <!-- Grids Container -->
        <div class="grids-wrapper">
          <!-- Horse Grid -->
          <div class="grid-section horse-section" *ngIf="selectedTypePosition === 'truck'">
            <h4 class="grid-title">
              <span class="icon">🚚</span>
              {{ horseConfig.name }}
            </h4>
            <div class="grid-wrapper">
              <!-- Steer Section -->
              <div class="axle-group">
                <div class="axle-label">Steer</div>
                <div class="grid grid-2">
                  <div class="Steer-row"  *ngFor="let slot of horseConfig.slots | slice:0:2">
                    <div 
                      [class.active]="slot.isActive"
                      (click)="onSlotClick(slot, 'horse')"
                      class="slot horse-slot">
                      <span>{{ slot.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
  
              <!-- Dynamic Drive Sections -->
              <div *ngFor="let drive of getAxleNumbers('horse'); let i = index" class="axle-group">
                <div class="axle-label">Drive {{ drive }}</div>
                <div *ngIf="horseConfig.slotsPerDrive === 4" class="drive-grid">
                  <div class="grid grid-2">
                    <div 
                      *ngFor="let slot of horseConfig.slots | slice:getAxleStart(i, 'horse'):getAxleStart(i, 'horse')+2"
                      [class.active]="slot.isActive"
                      (click)="onSlotClick(slot, 'horse')"
                      class="slot horse-slot">
                      <span>{{ slot.label }}</span>
                    </div>
                  </div>
                  <span class="separator">—</span>
                  <div class="grid grid-2">
                    <div 
                      *ngFor="let slot of horseConfig.slots | slice:getAxleStart(i, 'horse')+2:getAxleStart(i, 'horse')+4"
                      [class.active]="slot.isActive"
                      (click)="onSlotClick(slot, 'horse')"
                      class="slot horse-slot">
                      <span>{{ slot.label }}</span>
                    </div>
                  </div>
                </div>
                <div *ngIf="horseConfig.slotsPerDrive === 2" class="grid grid-2">
                  <div 
                    *ngFor="let slot of horseConfig.slots | slice:getAxleStart(i, 'horse'):getAxleStart(i, 'horse')+2"
                    [class.active]="slot.isActive"
                    (click)="onSlotClick(slot, 'horse')"
                    class="slot horse-slot">
                    <span>{{ slot.label }}</span>
                  </div>
                </div>
              </div>
    
              <!-- Spare Section -->
              <div *ngIf="horseConfig.hasSpare" class="axle-group">
                <div class="axle-label">Spare</div>
                <div class="grid grid-2">
                  <div 
                    *ngFor="let slot of horseConfig.slots | slice:horseConfig.slotCount-2:horseConfig.slotCount"
                    [class.active]="slot.isActive"
                    (click)="onSlotClick(slot, 'horse')"
                    class="slot horse-slot">
                    <span>{{ slot.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          <!-- Arrow Separator -->
          <!-- <div class="arrow-sep">→</div> -->
    
          <!-- Trailer Grid -->
          <div class="grid-section trailer-section" *ngIf="selectedTypePosition === 'trailer'">
            <h4 class="grid-title">
              <span class="icon">🚛</span>
              {{ trailerConfig.name }}
            </h4>
            <div class="grid-wrapper">
              <!-- Dynamic Axle Sections -->
              <div *ngFor="let axle of getAxleNumbers('trailer'); let i = index" class="axle-group">
                <div class="axle-label">Axle {{ axle }}</div>
                <div *ngIf="getAxleSlotCount(i, 'trailer') === 4" class="drive-grid">
                  <div class="grid grid-2">
                    <div 
                      *ngFor="let slot of trailerConfig.slots | slice:getAxleStart(i, 'trailer'):getAxleStart(i, 'trailer')+2"
                      [class.active]="slot.isActive"
                      (click)="onSlotClick(slot, 'trailer')"
                      class="slot trailer-slot">
                      <span>{{ slot.label }}</span>
                    </div>
                  </div>
                  <span class="separator">—</span>
                  <div class="grid grid-2">
                    <div 
                      *ngFor="let slot of trailerConfig.slots | slice:getAxleStart(i, 'trailer')+2:getAxleStart(i, 'trailer')+4"
                      [class.active]="slot.isActive"
                      (click)="onSlotClick(slot, 'trailer')"
                      class="slot trailer-slot">
                      <span>{{ slot.label }}</span>
                    </div>
                  </div>
                </div>
                <div *ngIf="getAxleSlotCount(i, 'trailer') === 2" class="grid grid-2">
                  <div 
                    *ngFor="let slot of trailerConfig.slots | slice:getAxleStart(i, 'trailer'):getAxleStart(i, 'trailer')+2"
                    [class.active]="slot.isActive"
                    (click)="onSlotClick(slot, 'trailer')"
                    class="slot trailer-slot">
                    <span>{{ slot.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <!-- Details Section -->
      <div class="details-section col-md-6 col-sm-12">
        <div class="section-header">
          <span class="title">TYRE ASSIGNMENT DETAILS</span>
        </div>
    
        <!-- Tyre Cards -->
        <div class="tyre-list">
          <div *ngFor="let tyre of tyreAssignments; let i = index" 
               [class]="'tyre-item ' + (tyre.component === 'Horse' ? '' : 'trailer-item') + (currentHighlightedTyre === tyre.id ? ' highlighted' : '')">
            
            <div class="item-header">
              <span class="item-title">Tyre #{{ padStart(i + 1) }}</span>
              <span class="item-id">{{ tyre.tyreNumber }}</span>
              <span class="item-label">{{ tyre.component }}</span>
              <!-- <button class="remove-btn" (click)="removeTyre(i)" *ngIf="tyreAssignments.length > 1">×</button> -->
            </div>
    
            <div class="item-body">
              <!-- Component -->
              <!-- <div class="field-group">
                <label class="field-label">COMPONENT</label>
                <div class="component-btns">
                  <button *ngFor="let comp of components"
                          [class.active]="tyre.component === comp"
                          [class.trailer-active]="tyre.component === comp && comp === 'Trailer'"
                          (click)="setTyreComponent(tyre, comp)"
                          class="comp-btn">
                    <span class="icon">{{ comp === 'Horse' ? '🚚' : '🚛' }}</span>
                    {{ comp }}
                  </button>
                </div>
              </div> -->
    
              <!-- Axle Position and Side Slot -->
              <div class="field-row">
                <div class="field-group">
                  <label class="field-label">AXLE POSITION</label>
                  <select [(ngModel)]="tyre.axlePosition" (ngModelChange)="onAxleChange(tyre, $event)" class="field-input">
                    <option *ngFor="let pos of getAxlePositions(tyre.component)" [value]="pos">{{ pos }}</option>
                  </select>
                </div>
                <div class="field-group">
                  <label class="field-label">SIDE & SLOT</label>
                  <select [(ngModel)]="tyre.sideSlot" (ngModelChange)="onTyreChange(tyre)" class="field-input">
                    <option *ngFor="let slot of getSideSlots(tyre.component, tyre.axlePosition)" [value]="slot">{{ slot }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <!-- Add Button -->
        <!-- <button (click)="addNewTyre()" class="add-btn">
          + Add Another Tyre Serial & Assign Position
        </button> -->
    
        <!-- Warning -->
        <!-- <div class="warning-box">
          <span class="icon">⚠️</span>
          Each position slot can only be assigned once. Duplicate positions will be flagged.
        </div> -->
      </div>
  </div>
  
    <!-- Footer -->
    <div class="footer">
      <button (click)="cancel()" class="btn-secondary">Cancel</button>
      <button (click)="saveTyreAssignments()" class="btn-primary">✓ Save Tyre Assignments</button>
    </div>
  </div>